import { FC } from 'react';

import { Alert, Button } from 'reactstrap';

import { Else, FontAwesomeIcon, IconButton, If, Then } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import { NotificationTime } from '@c/notifications/components/panel/components/time';

import { INotificationItemProps } from 'types/components/notifications/center';
import { s } from 'utilities/strings';

import { useNotificationItemConfiguration } from './hooks';

const NotificationItem: FC<INotificationItemProps> = ({
  notification: { createdAt, data, id, read, status, type },
  ...props
}) => {
  const { message, handleMarkAsRead, handleRemove } = useNotificationItemConfiguration({
    ...props,
    notification: { createdAt, data, id, read, status, type },
  });

  return (
    <Alert
      className="border d-flex mb-0 p-3 rounded-3"
      color={isDefined(type) ? type : 'default'}>
      <div className="d-flex flex-column flex-grow-1">
        <div>{message}</div>
        <NotificationTime createdAt={createdAt} />
      </div>
      <div className="d-flex flex-column ms-3">
        <If condition={read}>
          <Then>
            {() => (
              <FontAwesomeIcon
                className="text-success"
                icon={['fas', 'check']}
              />
            )}
          </Then>
          <Else>
            {() => (
              <Button
                className="p-0"
                color="link"
                data-tooltip-content={s(['Site.NotificationCenter.MarkRead'])}
                data-tooltip-id="global-tool-tip"
                onClick={handleMarkAsRead}>
                <FontAwesomeIcon
                  beatFade
                  className="text-primary"
                  icon={['fas', 'circle']}
                />
              </Button>
            )}
          </Else>
        </If>
        <IconButton
          className="p-0 text-secondary"
          color="link"
          data-tooltip-content={s(['Site.NotificationCenter.Delete'])}
          data-tooltip-id="global-tool-tip"
          icon={['fas', 'trash']}
          onClick={handleRemove}
        />
      </div>
    </Alert>
  );
};

export default NotificationItem;
